import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { campaignListForDisabledFailure, campaignListForDisabledSuccess } from '../../actions/campaignActions/campaignListForMarkDisabledActions';
import store from '../../configStore';

function* campaignListForDisabled({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getCampaignListForMarkDisabled,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_CAMPAIGN_LIST_FOR_MARK_DISABLED_SUCCESS status :", response.data.status);
        console.log("GET_CAMPAIGN_LIST_FOR_MARK_DISABLED_SUCCESS data :", response.data.response);
        console.log("GET_CAMPAIGN_LIST_FOR_MARK_DISABLED_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            campaignListForDisabledSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_CAMPAIGN_LIST_FOR_MARK_DISABLED_FAILURE status :", error?.response?.status);
        console.log("GET_CAMPAIGN_LIST_FOR_MARK_DISABLED_FAILURE data:", error?.response?.data);
        console.log("GET_CAMPAIGN_LIST_FOR_MARK_DISABLED_FAILURE error :", error);
        console.log('====================================');
        yield put(campaignListForDisabledFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* campaignListForDisabledSaga() {
    yield takeLatest(actionTypes.GET_CAMPAIGN_LIST_FOR_MARK_DISABLED_REQUEST, campaignListForDisabled);
}

export default campaignListForDisabledSaga;
